import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const sections = [
  {
    title: '1. 個人情報の収集について',
    content: `当サイト（以下「本サイト」）では、お問い合わせやサービスのお申し込みの際に、お名前・メールアドレス・電話番号・会社名などの個人情報をご提供いただく場合があります。これらの情報は、サービスの提供およびご連絡の目的にのみ使用します。`,
  },
  {
    title: '2. 個人情報の利用目的',
    content: `収集した個人情報は、以下の目的のために利用します。\n・お問い合わせへの返答およびサービスのご案内\n・サービス提供に必要な連絡・対応\n・業務上必要な場合の本人確認\n・各種サービス改善のための統計データ分析（個人を特定しない形式）`,
  },
  {
    title: '3. 個人情報の第三者提供',
    content: `当サービスは、法令に基づく場合を除き、ご本人の同意なく第三者に個人情報を提供することはありません。ただし、業務委託先（システム運用・支払い処理等）には必要な範囲で提供する場合があります。その際は適切な機密保持契約を締結します。`,
  },
  {
    title: '4. 個人情報の管理・保護',
    content: `個人情報への不正アクセス・紛失・破壊・改ざん・漏洩などのリスクに対し、合理的な安全対策を実施します。また、個人情報を取り扱う代表に対して適切な監督を行います。`,
  },
  {
    title: '5. Cookie（クッキー）の利用',
    content: `本サイトでは、サービス品質の向上および利便性向上のためにCookieを使用する場合があります。ブラウザの設定によりCookieを無効にすることが可能ですが、その場合一部機能が制限される場合があります。`,
  },
  {
    title: '6. アクセス解析ツール',
    content: `本サイトでは、Google Analytics等のアクセス解析ツールを利用する場合があります。これらのツールはCookieを使用してデータを収集しますが、個人を特定する情報は含まれません。`,
  },
  {
    title: '7. 個人情報の開示・訂正・削除',
    content: `ご本人から個人情報の開示・訂正・削除・利用停止をご希望される場合、下記のお問い合わせ先までご連絡ください。本人確認のうえ、合理的な範囲で対応いたします。`,
  },
  {
    title: '8. プライバシーポリシーの変更',
    content: `本ポリシーは、法令の改正やサービス変更に応じて予告なく改定する場合があります。変更後のポリシーは本ページに掲載した時点から効力を持つものとします。定期的にご確認ください。`,
  },
  {
    title: '9. お問い合わせ窓口',
    content: `個人情報の取り扱いに関するお問い合わせは、以下までお願いします。\n\n事業者名：GRAINN\n代表：後藤慎吾\nメール：goto_sn@grain-n.com\n電話：080-5353-0610\n住所：大阪府大阪市福島区福島`,
  },
];

export default function PrivacyPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <main className="min-h-screen">
      <title>プライバシーポリシー｜GRAINN</title>
      <meta name="description" content="GRAINNのプライバシーポリシー。個人情報の収集・利用目的・管理方法・第三者提供・お問い合わせ窓口についてご説明します。" />
      <meta name="robots" content="noindex, follow" />
      <Navbar />

      {/* Page Hero */}
      <section className="relative pt-44 pb-24 overflow-hidden bg-[#1C2B22]">
        <div className="absolute inset-0">
          <div className="absolute inset-0 bg-gradient-to-b from-[#1C2B22]/90 to-[#1C2B22]" />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10">
          <p className="text-[#C9A878] text-xs tracking-[0.4em] mb-5 uppercase">/ Privacy Policy</p>
          <h1 className="text-5xl md:text-6xl font-bold text-white tracking-tight leading-tight mb-6">
            プライバシーポリシー
          </h1>
          <div className="w-16 h-px bg-[#C9A878]/60 mb-6" />
          <p className="text-white/60 text-base max-w-xl leading-relaxed">
            当サービスにおける個人情報の取り扱いについてご説明します。
          </p>
          <div className="flex items-center gap-2 mt-8 text-xs text-white/30">
            <Link to="/" className="hover:text-white/60 transition-colors">ホーム</Link>
            <i className="ri-arrow-right-s-line" />
            <span className="text-white/60">プライバシーポリシー</span>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-20 bg-[#F8F5EF]">
        <div className="max-w-3xl mx-auto px-6 md:px-10">
          <div className="bg-white rounded-2xl p-8 md:p-12 mb-8">
            <p className="text-sm text-[#888] leading-relaxed mb-2">制定日：2026年1月1日</p>
            <p className="text-sm text-[#888] leading-relaxed">最終改定：2026年1月1日</p>
            <p className="text-sm text-[#555] leading-relaxed mt-6">
              GRAINN（以下「当社」）は、ウェブサイト制作・SNS運用代行・デジタルマーケティング支援サービスを通じてお客様からお預かりする個人情報の保護を重要な責務と認識し、以下のポリシーを定めます。
            </p>
          </div>

          <div className="space-y-6">
            {sections.map((section) => (
              <div key={section.title} className="bg-white rounded-2xl p-8 md:p-10">
                <h2 className="text-base font-bold text-[#1C2B22] mb-4 flex items-center gap-3">
                  <span className="w-1.5 h-5 bg-[#C9A878] rounded-full inline-block" />
                  {section.title}
                </h2>
                <p className="text-sm text-[#555] leading-relaxed whitespace-pre-line">
                  {section.content}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-[#F8F5EF]">
        <div className="max-w-2xl mx-auto px-6 text-center">
          <p className="text-[#888] text-sm mb-6">
            ご不明な点はお気軽にお問い合わせください。
          </p>
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 bg-[#2E5540] text-white px-10 py-4 rounded-full text-sm tracking-widest hover:bg-[#1C3A2A] transition-colors whitespace-nowrap"
          >
            <i className="ri-mail-send-line" />
            お問い合わせはこちら
          </Link>
        </div>
      </section>

      <Footer />
    </main>
  );
}
